// extracted by mini-css-extract-plugin
export default {"wrapper":"BusinessPartnerPickerWithPrefix_wrapper__2jvuk","prefix":"BusinessPartnerPickerWithPrefix_prefix__6ieW3","picker":"BusinessPartnerPickerWithPrefix_picker__5MmYu"};